import { round } from 'lodash';

export function filesize(mb: number): string {
	if (mb > 1) {
		return `${round(mb, 2)} mb`;
	} else {
		return `${round(mb * 1000)} kb`;
	}
}
